import { render, staticRenderFns } from "./DetectionDetail.vue?vue&type=template&id=62b8a6ca&scoped=true"
import script from "./DetectionDetail.vue?vue&type=script&lang=js"
export * from "./DetectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b8a6ca",
  null
  
)

export default component.exports